import { Component } from '@angular/core';

import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-file-upload-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ value || 'Geen bestand' }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <div class="file-upload-field">
                <ion-label>{{ field.label }}</ion-label>
                @if (field.helpText) {
                    <ion-note class="field-help">{{ field.helpText }}</ion-note>
                }
                <ion-item>
                    <input
                        type="file"
                        [accept]="field.validationRules || '*'"
                        (change)="onFileChange($event)">
                </ion-item>
                @if (value) {
                    <ion-note>Bestand geselecteerd: {{ value }}</ion-note>
                }
            </div>
        }
    `,
    styles: [`
        .file-upload-field {
            padding: 16px;
        }

        .file-upload-field ion-label {
            display: block;
            font-weight: 500;
            margin-bottom: 8px;
        }

        .field-help {
            display: block;
            padding: 4px 0;
            font-size: 12px;
            margin-bottom: 8px;
        }

        .field-label {
            color: var(--ion-color-medium);
            font-size: 12px;
        }

        .field-value {
            white-space: pre-wrap;
        }

        input[type="file"] {
            padding: 8px 0;
        }
    `]
})
export class FileUploadFieldComponent extends BaseFieldComponent {
    initialize(value: any): void {
        this.value = value ?? '';
    }

    serialize(): any {
        return this.value;
    }

    onFileChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            const file = input.files[0];
            // Emit the file object or file name depending on how it's processed
            this.emitChange(file.name);
        }
    }
}
